<template>
  <div class="UIPageLoader">
    <UILoader />
  </div>
</template>

<script lang="ts" setup>
import UILoader from './UILoader.vue'
</script>

<style scoped lang="scss">
.UIPageLoader {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
